/*
 * Helper de exibição de CNPJ mascarado de CANDIDATO (FE-3 CP-B).
 *
 * Vive num módulo próprio (não em `FilaConciliacao.tsx`) por uma restrição de
 * tooling: o `react-refresh/only-export-components` exige que um arquivo de
 * componente exporte SÓ componentes. Como este helper precisa ser exportado para
 * teste unitário, isolá-lo aqui mantém o Fast Refresh são sem perder a cobertura.
 */

const SEM_VALOR = "—";

/**
 * Exibe o CNPJ mascarado de um CANDIDATO defensivamente.
 *
 * Retorna "—" quando o valor é `null` OU a string literal `"None"`. O `"None"` é
 * um DEFEITO CONHECIDO do backend nos candidatos (a serialização do JSONB emite a
 * repr Python `"None"` em vez de `null`). FOLLOW-UP: candidatos emitem
 * `cnpj_masc:"None"`; remover o tratamento do `"None"` quando o backend alinhar o
 * campo para `null`.
 */
export function exibirCnpjMascarado(v: string | null): string {
  if (v === null || v === "None") {
    return SEM_VALOR;
  }
  return v;
}
